module.exports = __webpack_public_path__ + "static/img/40004 (2).b83afff.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40004 (2).webp
// module id = UzKb
// module chunks = 14